/* sayu — theme behaviour.
   Dependency-free, phone first. Prices are formatted in Liquid and
   passed through as strings, so this file never does money maths on
   its own beyond comparing integers in cents. */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ---------------------------------------------------------
     Announcement bar
     --------------------------------------------------------- */
  function announcement() {
    var bar = $("[data-announce]");
    if (!bar) return;
    var msgs = $$("span[data-msg]", bar);
    if (msgs.length < 2) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("on");
    }, 4200);
  }

  /* ---------------------------------------------------------
     Panels (nav drawer + cart drawer share the behaviour)
     --------------------------------------------------------- */
  function openPanel(el) {
    if (!el) return;
    el.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closePanel(el) {
    if (!el) return;
    el.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function panels() {
    $$("[data-panel-open]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        openPanel($("#" + btn.getAttribute("data-panel-open")));
      });
    });
    $$("[data-panel]").forEach(function (panel) {
      $$("[data-panel-close]", panel).forEach(function (btn) {
        btn.addEventListener("click", function () { closePanel(panel); });
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      $$("[data-panel]").forEach(function (p) {
        if (p.getAttribute("aria-hidden") === "false") closePanel(p);
      });
    });
  }

  /* ---------------------------------------------------------
     Accordions — one open at a time
     --------------------------------------------------------- */
  function accordions() {
    $$("[data-accordion]").forEach(function (group) {
      var items = $$(".item", group);
      items.forEach(function (item) {
        var btn = $("button", item);
        if (!btn) return;
        btn.addEventListener("click", function () {
          var wasOpen = item.classList.contains("open");
          items.forEach(function (other) {
            other.classList.remove("open");
            var s = $(".sign", other);
            if (s) s.textContent = "+";
            var b = $("button", other);
            if (b) b.setAttribute("aria-expanded", "false");
          });
          if (!wasOpen) {
            item.classList.add("open");
            var s = $(".sign", item);
            if (s) s.textContent = "−";
            btn.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  }

  /* ---------------------------------------------------------
     Collapsible copy — long editorial blocks fold on the phone
     and are always open from 720px up (CSS handles that).
     --------------------------------------------------------- */
  function collapsibles() {
    $$("[data-collapse]").forEach(function (box) {
      var btn = $(".collapse__btn", box);
      if (!btn) return;
      var more = btn.getAttribute("data-more") || "Read more";
      var less = btn.getAttribute("data-less") || "Read less";
      btn.textContent = more;
      btn.addEventListener("click", function () {
        var open = box.classList.toggle("is-open");
        btn.textContent = open ? less : more;
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }

  /* ---------------------------------------------------------
     Swipe rows — the dots follow the scroll position
     --------------------------------------------------------- */
  function swipeRows() {
    $$("[data-swipe]").forEach(function (row) {
      var rail = row.parentElement.querySelector("[data-swipe-rail]");
      if (!rail) return;
      var dots = $$("i", rail);
      if (!dots.length) return;
      var sync = function () {
        if (row.scrollWidth <= row.clientWidth + 4) return;
        var ratio = row.scrollLeft / (row.scrollWidth - row.clientWidth);
        var active = Math.round(ratio * (dots.length - 1));
        dots.forEach(function (d, i) { d.classList.toggle("on", i === active); });
      };
      row.addEventListener("scroll", sync, { passive: true });
      sync();
    });
  }

  /* ---------------------------------------------------------
     Cart
     --------------------------------------------------------- */
  var Cart = {
    drawer: function () { return $("#cart-drawer"); },

    refresh: function (html) {
      var drawer = Cart.drawer();
      if (!drawer || !html) return;
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var fresh = $("[data-cart-contents]", parsed);
      var target = $("[data-cart-contents]", drawer);
      if (fresh && target) target.innerHTML = fresh.innerHTML;
      Cart.bindLines();
    },

    setCount: function (n) {
      $$("[data-cart-count]").forEach(function (el) { el.textContent = n; });
    },

    add: function (id, qty) {
      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: id, quantity: qty || 1 }],
          sections: "cart-drawer"
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
          return r.json();
        })
        .then(function (data) {
          if (data.sections && data.sections["cart-drawer"]) {
            Cart.refresh(data.sections["cart-drawer"]);
          }
          return Cart.sync();
        });
    },

    change: function (key, qty) {
      return fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty, sections: "cart-drawer" })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections["cart-drawer"]) {
            Cart.refresh(data.sections["cart-drawer"]);
          }
          Cart.setCount(data.item_count);
          return data;
        });
    },

    sync: function () {
      return fetch(window.Shopify.routes.root + "cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.setCount(cart.item_count);
          return cart;
        });
    },

    bindLines: function () {
      $$("[data-line-change]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var key = btn.getAttribute("data-key");
          var qty = parseInt(btn.getAttribute("data-line-change"), 10);
          btn.disabled = true;
          Cart.change(key, qty);
        });
      });
    }
  };

  function cart() {
    if (!Cart.drawer()) return;
    Cart.bindLines();

    /* Quick add buttons anywhere on the site */
    $$("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.getAttribute("data-quick-add");
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Adding…";
        Cart.add(id, 1)
          .then(function () {
            btn.textContent = "Added";
            openPanel(Cart.drawer());
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2400);
          })
          .catch(function () {
            btn.textContent = original;
            btn.disabled = false;
          });
      });
    });
  }

  /* ---------------------------------------------------------
     Product page
     --------------------------------------------------------- */
  function product() {
    var root = $("[data-product]");
    if (!root) return;

    var dataEl = $("[data-product-json]", root);
    if (!dataEl) return;

    var payload;
    try { payload = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = payload.variants || [];
    if (!variants.length) return;

    /* Option positions. Any of the three may be absent on a simpler product. */
    var idx = payload.optionIndex; // { colour: 0|null, size: 1|null, set: 2|null }

    var state = {
      colour: null,
      size: null,
      set: null,
      shot: null,     // thumbnail override
      added: false
    };

    /* Seed state from the variant Shopify pre-selected */
    var initial = variants.filter(function (v) { return v.id === payload.selectedId; })[0] || variants[0];
    if (idx.colour !== null) state.colour = initial.options[idx.colour];
    if (idx.size !== null) state.size = initial.options[idx.size];
    if (idx.set !== null) state.set = initial.options[idx.set];

    function match(overrides) {
      var want = {
        colour: overrides && "colour" in overrides ? overrides.colour : state.colour,
        size: overrides && "size" in overrides ? overrides.size : state.size,
        set: overrides && "set" in overrides ? overrides.set : state.set
      };
      return variants.filter(function (v) {
        if (idx.colour !== null && v.options[idx.colour] !== want.colour) return false;
        if (idx.size !== null && v.options[idx.size] !== want.size) return false;
        if (idx.set !== null && v.options[idx.set] !== want.set) return false;
        return true;
      })[0] || null;
    }

    function currentVariant() { return match(null); }

    function setText(sel, value) {
      var el = $(sel, root);
      if (el) el.textContent = value;
    }
    function setHTML(sel, value) {
      var el = $(sel, root);
      if (el) el.innerHTML = value;
    }
    function show(sel, on) {
      var el = $(sel, root);
      if (el) el.style.display = on ? "" : "none";
    }

    function pressGroup(nodes, isOn) {
      nodes.forEach(function (n) { n.setAttribute("aria-pressed", isOn(n) ? "true" : "false"); });
    }

    function render() {
      var v = currentVariant();
      var available = !!(v && v.available);

      /* Price block */
      if (v) {
        setText("[data-price-now]", v.priceText);
        show("[data-price-was]", !!v.compareText);
        show("[data-price-save]", !!v.savePctText);
        if (v.compareText) setText("[data-price-was]", v.compareText);
        if (v.savePctText) setText("[data-price-save]", v.savePctText);
      }

      /* Gallery */
      var shotUrl = state.shot || (v && v.image) || payload.featuredImage;
      var mainImg = $("[data-main-image]", root);
      if (mainImg && shotUrl) mainImg.src = shotUrl;

      var stickyThumb = $("[data-sticky-thumb]", root);
      if (stickyThumb && shotUrl) stickyThumb.style.backgroundImage = 'url("' + shotUrl + '")';

      /* Swatches */
      var swatches = $$("[data-colour]", root);
      pressGroup(swatches, function (n) { return n.getAttribute("data-colour") === state.colour; });
      swatches.forEach(function (n) {
        var candidate = match({ colour: n.getAttribute("data-colour") });
        n.setAttribute("data-available", candidate && candidate.available ? "true" : "false");
      });
      setText("[data-colour-name]", state.colour || "");
      setText("[data-low-stock]", state.colour ? state.colour + " is running lowest." : "");

      /* Sizes */
      var sizes = $$("[data-size]", root);
      pressGroup(sizes, function (n) { return n.getAttribute("data-size") === state.size; });
      sizes.forEach(function (n) {
        var candidate = match({ size: n.getAttribute("data-size") });
        n.disabled = !(candidate && candidate.available);
      });

      /* Set tiers — reprice each card for the current colour and size */
      var tiers = $$("[data-set]", root);
      pressGroup(tiers, function (n) { return n.getAttribute("data-set") === state.set; });
      tiers.forEach(function (n) {
        var candidate = match({ set: n.getAttribute("data-set") });
        n.disabled = !(candidate && candidate.available);
        if (!candidate) return;
        var now = $("[data-tier-price]", n);
        var was = $("[data-tier-was]", n);
        var save = $("[data-tier-save]", n);
        if (now) now.textContent = candidate.priceText;
        if (was) {
          was.textContent = candidate.compareText || "";
          was.style.display = candidate.compareText ? "" : "none";
        }
        if (save) {
          save.textContent = candidate.saveText || "";
          save.style.display = candidate.saveText ? "" : "none";
        }
      });

      /* Spend-more ladder */
      var gwp = $("[data-gwp]", root);
      if (gwp && v) {
        var top = parseInt(gwp.getAttribute("data-gwp-top"), 10) || 250;
        var pct = Math.min(100, (v.price / 100) / top * 100);
        var fill = $("[data-gwp-fill]", gwp);
        if (fill) fill.style.width = pct + "%";
        $$("[data-rung]", gwp).forEach(function (rung) {
          var at = parseInt(rung.getAttribute("data-rung"), 10) * 100;
          rung.classList.toggle("met", v.price >= at);
        });
      }

      /* Order contents — driven by the chosen set */
      var includes = $("[data-includes]", root);
      if (includes && state.set) {
        var lines = (payload.includes && payload.includes[state.set]) || [];
        includes.innerHTML = "";
        lines.forEach(function (line) {
          var label = state.size && state.size.toLowerCase().indexOf("sheet") > -1
            ? line.replace(/bath towel/gi, "bath sheet")
            : line;
          var li = document.createElement("li");
          var tick = document.createElement("i");
          tick.textContent = "✓";
          var span = document.createElement("span");
          span.textContent = label;
          li.appendChild(tick);
          li.appendChild(span);
          includes.appendChild(li);
        });
      }

      /* Buttons. On the phone the sticky bar has no room for a separate price,
         so the price rides in the button label instead — people scroll a long
         way down a PDP and lose track of what they are about to pay. */
      var compact = window.matchMedia("(max-width: 979px)").matches;
      var label = available
        ? (state.added ? "Added to cart" : "Add to cart — " + v.priceText)
        : "Sold out";
      var shortLabel = available
        ? (state.added ? "Added" : (compact ? "Add to cart — " + v.priceText : "Add to cart"))
        : "Sold out";
      $$("[data-atc]", root).forEach(function (btn) {
        btn.disabled = !available;
        btn.dataset.added = state.added ? "1" : "0";
        btn.textContent = btn.hasAttribute("data-atc-short") ? shortLabel : label;
      });

      /* Sticky summary */
      var summary = [state.colour, state.set, state.size].filter(Boolean).join(" · ");
      setText("[data-sticky-summary]", summary);
      if (v) {
        setText("[data-sticky-price]", v.priceText);
        var sWas = $("[data-sticky-was]", root);
        if (sWas) {
          sWas.textContent = v.compareText || "";
          sWas.style.display = v.compareText ? "" : "none";
        }
      }

      /* Ship note follows the free-shipping threshold */
      var note = $("[data-ship-note]", root);
      /* The threshold is configured in USD; in another presentment currency
         the comparison against converted prices would lie, so the static
         server-rendered note stays as it is. */
      var usd = !window.Shopify || !Shopify.currency || Shopify.currency.active === "USD";
      if (note && v && usd) {
        var threshold = (parseInt(note.getAttribute("data-threshold"), 10) || 99) * 100;
        note.textContent = v.price >= threshold
          ? "Free shipping included · 30-night trial"
          : "Free shipping over " + note.getAttribute("data-threshold-text") + " · 30-night trial";
      }

      /* Keep the form and the URL honest */
      var input = $("[data-variant-input]", root);
      if (input && v) input.value = v.id;
      if (v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    /* --- interactions --- */
    $$("[data-colour]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.colour = btn.getAttribute("data-colour");
        state.shot = null;
        state.added = false;
        pressGroup($$("[data-thumb]", root), function () { return false; });
        render();
      });
    });

    $$("[data-size]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        state.size = btn.getAttribute("data-size");
        state.added = false;
        render();
      });
    });

    $$("[data-set]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        state.set = btn.getAttribute("data-set");
        state.added = false;
        render();
      });
    });

    $$("[data-thumb]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.shot = btn.getAttribute("data-thumb");
        pressGroup($$("[data-thumb]", root), function (n) { return n === btn; });
        render();
      });
    });

    $$("[data-atc]", root).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        var before = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Adding…";
        Cart.add(v.id, 1)
          .then(function () {
            state.added = true;
            render();
            openPanel(Cart.drawer());
          })
          .catch(function () {
            btn.textContent = before;
            btn.disabled = false;
          });
      });
    });

    /* Jump-to-buy links (used by the closing CTA) */
    $$("[data-jump-buy]").forEach(function (link) {
      link.addEventListener("click", function (e) {
        var setName = link.getAttribute("data-jump-buy");
        if (setName) {
          var target = $('[data-set="' + setName + '"]', root);
          if (target && !target.disabled) {
            state.set = setName;
            state.added = false;
            render();
          }
        }
        e.preventDefault();
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    /* Sticky buy bar */
    var sticky = $("[data-sticky-bar]");
    var mainAtc = $("[data-atc]:not([data-atc-short])", root);
    if (sticky && mainAtc) {
      var update = function () {
        var box = mainAtc.getBoundingClientRect();
        var atcVisible = box.top < window.innerHeight && box.bottom > 0;
        var nearFoot = window.innerHeight + window.scrollY > document.body.offsetHeight - 160;
        var scrolled = window.scrollY > 240;
        sticky.classList.toggle("on", scrolled && !atcVisible && !nearFoot);
      };
      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update, { passive: true });
      update();
    }

    render();
  }

  /* --------------------------------------------------------- */
  function init() {
    if (!window.Shopify) window.Shopify = {};
    if (!window.Shopify.routes) window.Shopify.routes = { root: "/" };
    announcement();
    panels();
    accordions();
    collapsibles();
    swipeRows();
    cart();
    product();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
